<template>
  <div>
    <h1 class="common__main-title">Tutor Evaluations</h1>
    <div>
      <Search
        class="search"
        @search="search"
        ref="search"
      />
      <div class="d-flex mb-3">
        <b-button
          pill
          variant="primary"
          class="mr-2"
          @click="exportCsv"
        >
          Export Csv
        </b-button>
        <b-button
          pill
          variant="primary"
          :to="{name:'EvaluationImport'}"
        >
          Upload
        </b-button>
      </div>
      <div class="pager-box">
        <Pager v-model="pager" @changePage="changePage" class="mb-2" />
      </div>
      <Evaluation :evaluations="evaluations"/>
      <div class="pager-box">
        <Pager v-model="pager" @changePage="changePage" />
      </div>
    </div>
    <Loading :isLoading="isLoading"/>
  </div>
</template>

<script>
import Pager from '@/components/parts/Pager.vue';
import Evaluation from '@/components/parts/evaluation/Evaluation.vue';
import Search from '@/components/parts/evaluation/EvaluationSearch.vue';
import Loading from '@/components/parts/modal/Loading.vue';
import { mapState } from 'vuex';
import _ from 'lodash';
import FileSaver from 'file-saver'

export default {

  data() {
    return {
      isLoading: false,
      isFetchingTutors: false,
    }
  },

  mounted() {
    this.search(this.$refs.search.conditions, this.pager.current)
  },

  computed: {
    ...mapState({
      evaluations: (state) => state.evaluations.evaluations,
      pager: (state) => state.evaluations.pager,
    }),
  },

  components: {
    Search,
    Pager,
    Evaluation,
    Loading,
  },

  methods: {
    // pager処理
    changePage(page) {
      this.search(this.$refs.search.conditions, page);
    },

    // 検索
    async search(conditions, page = 1) {
      this.isLoading = true;
      try {
        await this.$store.dispatch('fetchEvaluations', {
          conditions,
          page,
        });
      } finally {
        this.isLoading = false;
      }
    },
    async exportCsv() {
      this.isLoading = true;
      const { content, filename } = await this.$store.dispatch('exportEvaluationsByCsv', {
        conditions: this.$refs.search.conditions,
      });
      const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
      FileSaver.saveAs(blob, filename);
      this.isLoading = false;
    },
  },
};
</script>
